import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// ── Date formatting (DD-MM-YYYY convention) ──────────────────────────
// Renders dates day-first regardless of the visitor's browser locale.

// Format a date value as DD-MM-YYYY.
// Accepts a Date, an ISO datetime, or a plain "YYYY-MM-DD" string.
export function formatDate(value) {
  if (!value) return "";
  // Plain date-only strings: format directly to avoid UTC timezone shifting.
  if (typeof value === "string") {
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  }
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return typeof value === "string" ? value : "";
  return d.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, "-");
}

// Format a date value as DD-MM-YYYY, HH:mm.
export function formatDateTime(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return typeof value === "string" ? value : "";
  return d.toLocaleString("en-AU", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  }).replace(/\//g, "-");
}
